module.exports = __webpack_public_path__ + "static/img/16052C_5_6_R_20200529_fit.1b246ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/16052C_5_6_R_20200529_fit.png
// module id = v5RD
// module chunks = 0